import { AuthProviderProps } from 'react-oidc-context';
import { env } from './env';

const authority = env.OIDC_AUTHORITY;

export const oidcConfig: AuthProviderProps = {
  authority,
  client_id: env.OIDC_CLIENT_ID,
  redirect_uri: window.location.origin + '/callback',
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email roles portal.access',
  automaticSilentRenew: true,
  loadUserInfo: false, // Disable to avoid CORS on userinfo endpoint

  // Endpoints are discovered from `{authority}/.well-known/openid-configuration`
  // at runtime, so the provider is driven entirely by REACT_APP_OIDC_AUTHORITY
  // (see env.ts). No endpoints are hardcoded here.
};
